import moment from "moment";

export const splitDateTime = (dateTimeObj, format) => {
    if (format === 'TIME') {
        return moment(dateTimeObj).format('HH:mm')
    } else if (format === 'DATE') {
        return moment(dateTimeObj).format('YYYY-MM-DD')
    }
}